import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-backtostock',
    templateUrl: './backtostock.page.html',
    styleUrls: ['./backtostock.page.scss'],
})
export class BacktostockPage implements OnInit {

    constructor() {
    }

    ngOnInit() {
        let date = new Date();
        let month = date.getUTCMonth()
        if (month == 0) month = 12;
        let sdate = date.getFullYear() + '/' + month + '/' + date.getUTCDate();
        //console.logsdate)
    }

}
